<template>
    <spinner :loading="loading">
        <div class="field is-grouped">
            <column-selector
                :library-name="library.name"
                :name-alias="library.nameAlias"
                :columns="columns"
                @hidden="displayColumnFilter($event, false)"
                @visible="displayColumnFilter($event, true)" />

            <ref-code-display-selector
                :library-name="library.name"
                :columns="columns"
                @change="onChangeCodeRefDisplayMode" />
        </div>
    </spinner>
</template>

<script>
    import RefCodeDisplaySelector from './RefCodeDisplaySelector.vue';
    import ColumnSelector from './ColumnSelector.vue';
    import { createCodeDefArray } from '@/shared/helpers/dataHelpers.ts';
    import Spinner from '@/shared/components/Spinner.vue';
    export default {
        components: {
            RefCodeDisplaySelector,
            ColumnSelector,
            Spinner
        },
        props: {
            library: {
                type: Object,
                required: true
            }
        },
        emits: [
            'column-visibility',
            'coderef-display-mode'
        ],
        data() {
            return {
                columns: null,
                loading: true
            };
        },
        async mounted() {
            this.columns = createCodeDefArray(this.library.attributeDefinitions);
            this.loading = false;
        },
        methods: {
            displayColumnFilter(col, displayBool) {
                this.$emit('column-visibility', (columns) => {
                    columns.find(c => c.field === col).visible = displayBool;
                });
            },
            onChangeCodeRefDisplayMode(col) {
                this.$emit('coderef-display-mode', (columns) => {
                    columns.find(c => c.field === col.field).referenceDisplayMode = col.referenceDisplayMode;
                });
            }
        }
    };
</script>

<style>

</style>
